import React from 'react';
import { Row, SaladTable, ViewFieldType } from 'saladsoft-primitive';
import { AdminVoucherCategoryDto } from 'services/data-contracts';

const VoucherCategoryView = ({ voucherCategory }: { voucherCategory: AdminVoucherCategoryDto }) => {
  const fields: ViewFieldType<AdminVoucherCategoryDto>[] = [
    // { isGroup: true, key: 'voucherCategory', label: '카테고리 정보' },
    {
      key: 'creator' as const,
      path: 'username',
      label: '작성자',
      controlType: 'text',
    },
    {
      key: 'localizedName' as const,
      path: 'localizedName',
      label: '카테고리명',
      value: voucherCategory.localizedName,

      controlType: 'custom',
      template:
        <Row gap={10} flexDirection='column' alignItems='flex-start'>
          <div>{voucherCategory.localizedName?.['ko']}</div>
          <div>{voucherCategory.localizedName?.['en']}</div>
          <div>{voucherCategory.localizedName?.['ja']}</div>
          <div>{voucherCategory.localizedName?.['zh']}</div>
        </Row>,
    },
    {
      key: 'localizedDesc' as const,
      path: 'localizedDesc',
      label: '카테고리 설명',
      value: voucherCategory.localizedDesc,
      controlType: 'custom',
      template:
        <Row gap={10} flexDirection='column' alignItems='flex-start'>
          <div>{voucherCategory.localizedDesc?.['ko']}</div>
          <div>{voucherCategory.localizedDesc?.['en']}</div>
          <div>{voucherCategory.localizedDesc?.['ja']}</div>
          <div>{voucherCategory.localizedDesc?.['zh']}</div>
        </Row>,
    },

    {
      key: 'createDate' as const,
      path: 'createDate',
      label: '생성일',
      value: voucherCategory.createDate,
      controlType: 'datetime',
    },
  ];

  return (
    <div style={{ paddingBottom: 40 }}>
      <SaladTable.SaladView fields={fields as any} values={voucherCategory} />
    </div>
  );
};

export default VoucherCategoryView;
